import { render, staticRenderFns } from "./register-container.vue?vue&type=template&id=22cc616a&"
import script from "./register-container.vue?vue&type=script&lang=ts&"
export * from "./register-container.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports